// extracted by mini-css-extract-plugin
export default {"container":"Alert_container__CmMc2"};